import { render, staticRenderFns } from "./reportServer.vue?vue&type=template&id=15246a10&scoped=true&"
import script from "./reportServer.vue?vue&type=script&lang=js&"
export * from "./reportServer.vue?vue&type=script&lang=js&"
import style0 from "./reportServer.vue?vue&type=style&index=0&id=15246a10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15246a10",
  null
  
)

export default component.exports